<template>
  <div class="create-employe">
    <el-backtop target=".create-employe"></el-backtop>
    <header-top :headerText="headerText" showBack></header-top>
    <div class="basic-info">
      <el-form
        label-position="left"
        label-width="10rem"
        ref="companyForm"
        :rules="companyRules"
        :model="company"
      >
        <!-- 基本信息 -->
        <div class="basic-item">
          <div class="basic-item-title">基本信息</div>
          <div class="basic-item-main">
            <!-- 左 -->
            <div class="main-item">
              <el-form-item label="分销商封面" class="auto-height">
                <div class="basic-head">
                  <div class="basic-head-item">
                    <img
                      src="@/assets/image/default-img.png"
                      alt="default"
                      class="default-img"
                      v-if="!photoUrl"
                    />
                    <el-image
                      v-else
                      class="basic-head-img"
                      :src="photoUrl"
                      fit="cover"
                    ></el-image>
                    <el-upload
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :on-change="uploadChange"
                      list-type="picture"
                      :before-upload="beforeAvatarUpload"
                      :show-file-list="false"
                      :http-request="getFile"
                      accept=".jpg, .png, .jpeg"
                    >
                      <el-button class="upload-btn">{{
                        photoUrl ? "更换" : "上传"
                      }}封面</el-button>
                    </el-upload>
                  </div>
                  <div class="form-tip">
                    注意：建议上传格式为jpg/jpeg/png且大小不超过5MB的图片
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="分销商名称" prop="name">
                <el-input
                  v-model="company.name"
                  placeholder="请输入分销商名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="分销商简称">
                <el-input
                  v-model="company.alias"
                  placeholder="请输入分销商简称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                label="分销商类型"
                prop="type"
              >
                <el-select
                  v-model="company.type"
                  clearable
                  placeholder="请选择分销商类型"
                >
                  <el-option
                    v-for="item in companyTypeOptions"
                    :key="item.value"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="是否有房地产经纪资质"
                prop="hasQualifications"
              >
                <el-radio-group v-model="company.hasQualifications">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="联系电话" prop="phoneNumber">
                <el-input
                  v-model="company.phoneNumber"
                  placeholder="请输入联系电话"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" prop="email">
                <el-input
                  v-model="company.email"
                  placeholder="请输入电子邮箱"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <!-- 右 -->
            <div class="main-item basic-item-right main-item-flex">
              <!-- <el-form-item label="加盟渠道来源">
                <el-select
                  v-model="company.recruitWay"
                  clearable
                  placeholder="请选择加盟渠道来源"
                >
                  <el-option
                    v-for="item in recruitWayOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item
                label="分销商状态"
                prop="status"
              >
                <el-radio-group v-model="company.status">
                  <el-radio
                    v-for="(item, index) in companyStatusOptions"
                    :key="index"
                    :label="item.key"
                    >{{ item.value }}</el-radio
                  >
                </el-radio-group>
              </el-form-item> -->
              <el-form-item label="营业执照号码" prop="businessLicense">
                <el-input
                  v-model="company.businessLicense"
                  placeholder="请输入营业执照号码"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="工商注册地址">
                <el-input
                  v-model="company.registerAddress"
                  placeholder="请输入工商注册地址"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="实际经营地址">
                <el-input
                  v-model="company.currentAddress"
                  placeholder="请输入实际经营地址"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="公司法人" prop="owner">
                <el-input
                  v-model="company.owner"
                  placeholder="请输入公司法人"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item
                label="公司性质"
                prop="nature"
              >
                <el-radio-group v-model="company.nature">
                  <el-radio
                    v-for="(item, index) in companyNatureOptions"
                    :key="index"
                    :label="item.option"
                    >{{ item.option }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="法人联系电话" prop="ownerPhoneNumber">
                <el-input
                  v-model="company.ownerPhoneNumber"
                  placeholder="请输入公司法人联系电话"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="法人证件类型" prop="ownerCardType">
                <el-select
                  v-model="company.ownerCardType"
                  clearable
                  placeholder="请选择公司法人证件类型"
                >
                  <el-option
                    v-for="item in ownerCardTypeOptions"
                    :key="item.option"
                    :label="item.option"
                    :value="item.option"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="法人证件号码" prop="ownerCardNumber">
                <el-input
                  v-model="company.ownerCardNumber"
                  placeholder="请输入公司法人证件号码"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="目标店数" prop="totalMembers">
                <el-input
                  v-model="company.totalMembers"
                  placeholder="请输入目标店数"
                  clearable
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="备注" class="auto-height">
                <el-input
                  type="textarea"
                  resize="none"
                  :rows="2"
                  placeholder="请输入备注"
                  v-model="company.more"
                ></el-input>
              </el-form-item> -->
            </div>
          </div>
        </div>
        <!-- 股东信息 -->
        <div class="basic-item">
          <div class="basic-item-title">
            股东信息
          </div>
          <el-button type="primary" @click="addPartners" class="add-position"
            >添加股东</el-button
          >
          <el-table
            :data="company.partners"
            style="width: 100%"
            header-align="center"
          >
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="cardType" label="证件类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cardNumber" label="证件号" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="phoneNumber"
              label="电话号码"
            ></el-table-column>
            <el-table-column prop="more" label="备注" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.more | nullValue }}
              </template>
            </el-table-column>
            <el-table-column prop="more" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="editPartners(scope.$index, scope.row)"
                  type="text"
                  
                  >修改</el-button
                >
                <el-button
                  @click.native.prevent="deletePartners(scope.$index)"
                  type="text"
                  
                  class="del-btn"
                  v-if="!scope.row.isMajor"
                  >移除</el-button
                >
              </template>
            </el-table-column>
            <template slot="empty">当前股东列表为空</template>
          </el-table>
        </div>
        <div class="group-btn">
          <el-button
            type="primary"
            @click="createCompany('companyForm')"
            :loading="submitLoading"
            >保存</el-button
          >
          <el-button @click="$router.go(-1)">取消</el-button>
        </div>
      </el-form>
      <el-dialog
        :title="editPartnersIndex == null ? '添加股东' : '编辑股东'"
        :visible.sync="isAddPartnersShow"
        width="578px"
        custom-class="employe-position"
        @close="handleClose('partnersForm')"
      >
        <el-form
          :model="partnersForm"
          label-position="left"
          label-width="6rem"
          :rules="partnersRules"
          ref="partnersForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="partnersForm.name"
              placeholder="请输入股东姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="股东证件类型" prop="cardType">
            <el-select
              v-model="partnersForm.cardType"
              clearable
              placeholder="请选择股东证件类型"
            >
              <el-option
                v-for="item in ownerCardTypeOptions"
                :key="item.option"
                :label="item.option"
                :value="item.option"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="股东证件号" prop="cardNumber">
            <el-input
              v-model="partnersForm.cardNumber"
              placeholder="请输入股东证件号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="股东电话" prop="phoneNumber">
            <el-input
              v-model="partnersForm.phoneNumber"
              placeholder="请输入股东电话"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="more" class="auto-height">
            <el-input
              type="textarea"
              v-model="partnersForm.more"
              maxlength="200"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isAddPartnersShow = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('partnersForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import indexJs from './index.js';
export default {
  ...indexJs
}
</script>

<style lang="scss" scoped>
.create-employe {
  background-color: #f2f2f2;
  height: calc(100vh - 50px);
  overflow-y: scroll;

  // @media (max-width: 1440px) {
  //   .basic-info {
  //     margin: 20px;
  //   }

  //   .up-top {
  //     display: none;
  //   }
  // }

  // @media (min-width: 1440px) and (max-width: 1680px) {
  //   .basic-info {
  //     margin: 20px 70px;
  //   }

  //   .up-top {
  //     right: 5px;
  //     bottom: 5px;
  //   }
  // }

  // @media (min-width: 1680px) and (max-width: 1920px) {
  //   .basic-info {
  //     margin: 20px 120px;
  //   }
  // }

  // @media (min-width: 1920px) {
  //   .basic-info {
  //     margin: 20px 180px;
  //   }
  // }

  .basic-info {
    margin: 20px;
    padding: 20px;
    border-radius: $--border-radius-base;
    text-align: left;
    min-width: 960px;
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);    
    background-color: #fff;
    .basic-item {
      .post-symbol {
        color: #f56c6c;
      }
      .basic-item-title {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
      }

      .add-position {
        margin-bottom: 10px;
      }

      .basic-item-main {
        margin-bottom: 25px;
        padding-bottom: 15px;
        display: flex;
        border-bottom: 1px solid #ddd;

        .main-item {
          width: 50%;

          .el-select,
          .el-input,
          .el-textarea {
            width: 330px;
          }

          .basic-head {
            .basic-head-item {
              display: flex;
              align-items: flex-end;
              margin-bottom: 8px;
              line-height: 0;

              .default-img,
              .basic-head-img {
                margin-right: 10px;
                width: 143px;
                height: 148px;
              }

              .upload-btn {
                border: 1px solid rgba(221, 221, 221, 1);
                width: 110px;
                height: 30px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
              }
            }
          }

          .account-lock {
            display: inline-block;
            margin-right: 5px;
          }

          .lock-svg {
            margin-top: -2px;
          }

          .work-age {
            display: flex;
            width: 330px;

            .el-input {
              width: 50%;
              &:first-child {
                ::v-deep .el-input-group__append {
                  border-right-color: transparent;
                }
              }
            }
          }

          ::v-deep .el-form-item__content {
            .el-input-group {
              vertical-align: baseline;
            }
          }
        }

        .basic-item-right {
          padding-left: 50px;
        }
      }

      .el-table {
        margin-bottom: 25px;
        .table-empty {
          color: $--color-primary;
          cursor: pointer;
        }
        .grade-box {
          display: flex;
          align-items: center;

          .grade-main {
            margin-left: 9px;
            border: 1px solid $--color-primary;
            padding: 0 5px;

            font-size: 12px;
            font-weight: 400;
            line-height: 18px;

            color: $--color-primary;
          }
        }
      }
    }

    .group-btn {
      margin-top: -5px;
    }

    ::v-deep .employe-position {
      .el-dialog__header {
        padding: 25px 25px 20px 25px;
      }

      .el-dialog__body {
        padding: 0 25px;

        .el-input,
        .el-select,
        .el-textarea {
          width: 396px;
        }

        .vue-treeselect__input-container {
          height: 28px;
        }

        .vue-treeselect__menu {
          width: 350px;
        }
      }

      .el-dialog__footer {
        padding: 15px 25px 25px 25px;
      }
    }
  }
}
</style>